
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.563 35.669l-6.232-6.231A1.499 1.499 0 0032.27 29h-1.02A12.936 12.936 0 0034 21c0-7.181-5.819-13-13-13S8 13.819 8 21s5.819 13 13 13c3.019 0 5.794-1.025 8-2.75v1.019c0 .4.156.781.438 1.062l6.23 6.231a1.494 1.494 0 002.12 0l1.768-1.768a1.507 1.507 0 00.007-2.125zM21 29c-4.419 0-8-3.575-8-8 0-4.419 3.575-8 8-8 4.419 0 8 3.575 8 8 0 4.419-3.575 8-8 8z","fill":"#535353"}})])
          )
        }
      }
    